/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */
import { LOCATION_CHANGE } from 'connected-react-router';
import { get } from 'lodash';
import {
  GENERIC_ERROR,
  ERROR_TYPE_QUESTIONNAIRE_VERSION,
  ERROR_TYPE_QUESTIONNAIRE_AND_TARGETING_VERSIONS,
  ERROR_TYPE_PEEQ_COMMUNICATION,
} from 'containers/App/constants';

// The initial state of the App
const initialState = {
  genericError: false,
  routes: [],
};

const getSpecificError = (error) => {
  const errors = get(error, 'body.errors', []);

  switch (true) {
    case errors.includes(ERROR_TYPE_QUESTIONNAIRE_AND_TARGETING_VERSIONS) ||
      errors.includes(ERROR_TYPE_QUESTIONNAIRE_VERSION):
      return { error, type: ERROR_TYPE_QUESTIONNAIRE_VERSION };
    case errors.includes(ERROR_TYPE_PEEQ_COMMUNICATION):
      return { error, type: ERROR_TYPE_PEEQ_COMMUNICATION };
    default:
      return { error };
  }
};

function appReducer(state = initialState, action) {
  switch (action.type) {
    case GENERIC_ERROR: {
      const error = getSpecificError(action.error);

      return Object.assign({}, state, {
        genericError: true,
        error,
      });
    }
    case LOCATION_CHANGE:
      return Object.assign({}, state, {
        routes: [...state.routes, action.payload],
      });
    default:
      return state;
  }
}

export default appReducer;
